
import i1 from '../src/Images/i1.webp';
import i2 from '../src/Images/i2.webp';
import i3 from '../src/Images/i3.webp';
import i4 from '../src/Images/i4.webp';

export const services = [
    {
      titleTop: "Lovely",
      title: "HAIRCUTS",
      subtitle: "TRENDY • LATEST LOOKS",
      dark: false,
    },
    {
      titleTop: "Change",
      title: "COLORING",
      subtitle: "EXCEPTIONAL • INNOVATIVE",
      dark: true,
    },
    {
      titleTop: "Perfect",
      title: "HAIRSTYLES",
      subtitle: "CHIC • TRENDING",
      dark: false,
    },
  ];

export const insta=[
  {img:i1},
  {img:i2},
  {img:i3},
  {img:i4},
]
